/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-08-27 09:36:19
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-18 15:25:54
 */
import { request } from './request'

export const getList = data => request({
  method: 'get',
  url: '/api/v1/admin/bm/user',
  params: data
})

export const getLogList = (userId, params) => request({
  method: 'get',
  url: `/api/v1/admin/bm/user/${userId}/log`,
  params
})

export const updateInfo = (userId, data) => request({
  method: 'put',
  url: `/api/v1/admin/bm/user/${userId}`,
  data
})

export const getDetail = (userId) => request({
  method: 'get',
  url: `/api/v1/admin/bm/user/${userId}`,
})
// 商户列表
export const getMerchantShopList = (userId, data) => request({
  method: 'post',
  url: `${process.env.VUE_APP_BASEURL_USER}/api/v1/user/permission/authorized/merchant/list`,
  data
})

